import { IDoctorScheduled, IResponseData } from '@/models/common';
import {
  IDoctorListItem,
  IDoctor,
  ISaveMyDoctorInfo,
  PossibleTypes,
  IDoctorItem,
  IFacilityDept,
  IDepts,
} from '@/models/doctor';
import { RequestKindTypes } from '@/models/request';
import { AxiosResponse } from 'axios';
import api from '../api/api';
import getApiResponse from '../api/apiResponse';
import { ApiDoctor } from './';

import doctorImageDb from '../db/doctor';

/**
 * 의사 목록
 * @param {PossibleTypes} possibleTypes
  ALL = 1,
  ONLINE_CARE = 2,
  SECOND_OPINION = 3
  {@link PossibleTypes}
 */
export const getDoctorList = async (possibleTypes: PossibleTypes, hospitalKey?: Number | null) => {
  const doctor: IDoctor = {} as IDoctor;
  try {
    doctor.doctorList = await DoctorService.getDoctorList(possibleTypes, hospitalKey);
    doctor.doctorList.sort((p: IDoctorListItem, n: IDoctorListItem) => {
      return n.MyDoctor - p.MyDoctor;
    });

    //의사 이미지 가져오기
    await Promise.all(
      doctor.doctorList.map(async (doctor: IDoctorListItem) => {
        doctor.Image = await getDoctorImage(doctor.DoctorKey);
      })
    );
    return doctor;
  } catch (ex) {
    console.warn(ex);
    doctor.doctorList = [];
    return doctor;
  }
};
/**
 * 의사 이미지 가져오기
 * @param key 의사 키
 * @returns
 */
export const getDoctorImage = async (key: Number) => {
  console.log('getDoctorImage=>' + key);
  const img = await doctorImageDb.findImage(key);
  console.log(img, 'getDoctorImage.img');
  if (img) {
    return URL.createObjectURL(img);
  }

  const imgBlob = await DoctorService.getDoctorProfileImage(key.toString());
  console.log(imgBlob, 'getDoctorImage.imgBlob');
  if (imgBlob) {
    doctorImageDb.saveImage(key.valueOf(), imgBlob);
  }

  return URL.createObjectURL(imgBlob);
};

/**
 *
 * @param key 의사 키
 *
 */
export const getDoctor = async (key: string) => {
  try {
    const doctor = await DoctorService.getDoctor(key);

    if (!!doctor && !Array.isArray(doctor)) {
      const imgBlob = await DoctorService.getDoctorProfileImage(key);
      doctor.Image = URL.createObjectURL(imgBlob);
      return doctor;
    }
    return {} as IDoctorListItem;
  } catch (ex) {
    console.warn(ex);
    return {} as IDoctorListItem;
  }
};

// 기관 의사 목록 조회  (내 의사 + 기관 의사)
export const getFacilityDoctorList = async (possibleType: null | PossibleTypes, facilityKey?: Number | null) => {
  if (!possibleType) possibleType = PossibleTypes.ALL;

  const params = {
    possibleType: possibleType,
    facilityKey: facilityKey,
  };
  const resp: AxiosResponse<IResponseData<Array<IDoctorListItem>>> = await api.get(ApiDoctor.FACILITY_DOCTOR_LIST, {
    params,
  });

  const doctors = getApiResponse<Array<IDoctorListItem>>(resp);
  console.log(doctors, 'getFacilityDoctorList.doctors');
  if (doctors === undefined) {
    return doctors;
  }

  //의사 이미지 가져오기
  await Promise.all(
    doctors.map(async (doctor: IDoctorListItem) => {
      console.log(doctor, 'getFacilityDoctorList.doctor');
      const image = await doctorImageDb.findImage(doctor.DoctorKey);
      if (image) {
        doctor.Image = URL.createObjectURL(image);
      } else {
        doctor.Image = await getDoctorImage(doctor.DoctorKey);
      }
    })
  );
  // console.log(doctors, 'getFacilityDoctorList.doctors2');

  return doctors;

  //return Promise.all(doctors);

  // return await (await axios.get('/demo/data/doctors.json')).data.data;
};

// 기관 진료과 조회  (기관 진료과)
export const getFacilityDeptsList = async (fKey: number) => {
  const params = {
    fKey,
  };

  const resp: AxiosResponse<IResponseData<Array<IFacilityDept>>> = await api.get(ApiDoctor.FACILITY_DEPTS_LIST, {
    params,
  });

  return getApiResponse<Array<IFacilityDept>>(resp);
};

//
// Doctor Service
//
export const DoctorService = {
  /**
   *
   * @param key 의사키
   * @returns IDoctorItem
   */
  async getDoctorItem(key: string) {
    try {
      const params = { key };
      const res: AxiosResponse<IResponseData<IDoctorItem>> = await api.get(ApiDoctor.DOCTOR_ITEM, { params });

      return getApiResponse<IDoctorItem>(res);
      // const {
      //   data: { ResultData },
      // } = res;

      // if (!!ResultData && !Array.isArray(ResultData)) {
      //   ResultData.Image = await getDoctorImage(Number.parseInt(key));
      //   return ResultData;
      // }
      // return {} as IDoctorItem;
    } catch (ex) {
      console.warn(ex);
      return {} as IDoctorItem;
    }
  },

  async getDoctorList(possible: null | PossibleTypes, facilityKey?: Number | null) {
    if (!possible) possible = PossibleTypes.ALL;

    const params = {
      possibleType: possible,
      facilityKey: facilityKey,
    };

    const res: AxiosResponse<IResponseData<Array<IDoctorListItem>>> = await api.get(ApiDoctor.DOCTOR_LIST, { params });
    return getApiResponse<Array<IDoctorListItem>>(res);
    // return await (await axios.get('/demo/data/doctors.json')).data.data;
  },

  async getScheduled(doctorkey: Number, requestKind: RequestKindTypes) {
    const params = {
      doctorkey,
      requestKind,
    };

    const res: AxiosResponse<IResponseData<IDoctorScheduled>> = await api.get(ApiDoctor.DOCTOR_SCHEDULEDS, { params });
    return getApiResponse<IDoctorScheduled>(res);
  },

  async getDoctorProfileImage(key: String) {
    const params = {
      key,
    };
    const res: AxiosResponse<Blob> = await api.get(ApiDoctor.DOCTOR_PROFILE_IMAGE, {
      params,
      responseType: 'blob',
    });
    console.log(res, 'getDoctorProfileImage.res');
    return res.data;
  },

  async SaveMyDoctorInfo(data: ISaveMyDoctorInfo) {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiDoctor.SAVE_MY_DOCTOR_INFO, data);
    return getApiResponse<string>(res);
  },

  async getDeptsList() {
    const res: AxiosResponse<IResponseData<IDepts>> = await api.get(ApiDoctor.DEPTS_LIST);
    return getApiResponse<IDepts>(res);
  },

  async getDoctor(key: String) {
    const params = { key };
    const res: AxiosResponse<IResponseData<IDoctorListItem>> = await api.get(ApiDoctor.DOCTOR, { params });
    return getApiResponse<IDoctorListItem>(res);
  },
};

export default DoctorService;
